export default (state, action) => {
  return Object.assign({}, state, {
    data: { ...state.customer, resetPassword: action.status }
  });
};
